import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {
  FiAlertCircle,
  FiBarChart2,
  FiChevronDown,
  FiChevronRight,
  FiClipboard,
  FiCode,
  FiFileText,
  FiLayers,
  FiPenTool,
  FiSettings,
  FiUser,
} from 'react-icons/fi'
import {
  VmoButton,
  VmoMenu,
  VmoMenuItem,
  VmoAccordion,
  VmoAccordionContent,
  VmoAccordionTitle,
  VmoMenuHeader,
  VmoIcon,
  VmoTooltip,
} from 'vmo-library'
import {useSelector} from 'react-redux'
import {getPathWithPrefix, isActiveNavlink} from 'utils/helper'
import {STATUS_PAGE_PATH} from 'constants/path'

const StatusPageMenu = () => {
  const navigate = useNavigate()
  const [expand, setExpand] = useState([])
  const [isSettingOpen, setIsSettingOpen] = useState(true)

  const {GetPageSettingsData = {}} = useSelector(state => state.statuspage)
  const menuItems = [
    {path: STATUS_PAGE_PATH.INCIDENTS, icon: <FiFileText />, label: 'Incidents'},
    {path: STATUS_PAGE_PATH.MAINTENANCE, icon: <FiAlertCircle />, label: 'Maintenance'},
    {path: STATUS_PAGE_PATH.SERVICE_COMPONENTS, icon: <FiLayers />, label: 'Service Components'},
    {path: STATUS_PAGE_PATH.CUSTOMIZATION, icon: <FiPenTool />, label: 'Customization'},
    {path: STATUS_PAGE_PATH.MANAGE_SUBSCRIBERS, icon: <FiUser />, label: 'Manage Subscribers'},
  ]
  const accordionItems = [
    {
      title: 'Settings',
      key: 'setting-accordion',
      items: [
        {
          label: 'General',
          icon: <FiSettings />,
          path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.GENERAL),
        },
        {
          label: 'Status Embed',
          icon: <FiCode />,
          path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.STATUS_EMBED),
        },
        {
          label: 'Templates',
          icon: <FiClipboard />,
          path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.TEMPLATES),
        },
        {
          label: 'Incident Sources',
          icon: <FiCode />,
          path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.INCIDENT_SOURCES),
        },
        {
          label: 'Incident Status',
          icon: <FiBarChart2 />,
          path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.INCIDENT_STATUS),
        },
      ],
    },
  ]
  const handleMenuExpand = key => {
    const menus = [...expand]
    if (menus.includes(key)) {
      menus.splice(menus.indexOf(key), 1)
      setExpand(menus)
    } else {
      setExpand([...menus, key])
    }
  }
  const isActive = key => {
    if (expand.length === 0) return true
    return expand.includes(key)
  }
  return (
    <VmoMenu vertical secondary className="set-list">
      <VmoMenuHeader style={{marginBottom: '0.5em'}}>{GetPageSettingsData?.pageSetting?.pageTitle}</VmoMenuHeader>
      {menuItems.map((menu, idx) => (
        <VmoMenuItem
          key={menu.path}
          className="articleTool mb-0"
          active={isActiveNavlink(menu.path)}
          onClick={() => navigate(`/${STATUS_PAGE_PATH.PREFIX}/${menu.path}`)}
        >
          {menu.icon} {menu.label}
        </VmoMenuItem>
      ))}
      {accordionItems.map((accor, idx) => (
        <VmoAccordion key={idx}>
          <VmoAccordionTitle onClick={() => setIsSettingOpen(!isSettingOpen)}>
            {accor.title}
            {isActive(accor.key) ? <FiChevronDown /> : <FiChevronRight />}
          </VmoAccordionTitle>

          <VmoAccordionContent active={isActive(accor.key)}>
            {accor.items.map((item, idx) => (
              <VmoMenuItem key={item.path} active={isActiveNavlink(item.path)} onClick={() => navigate(item.path)}>
                {item.icon} {item.label}
              </VmoMenuItem>
            ))}
          </VmoAccordionContent>
        </VmoAccordion>
      ))}
      <div className="prevBottom">
        <VmoTooltip
          content="Preview Status page"
          trigger={
            <VmoButton
              fluid
              className="basic-fill-btn"
              href={`https://${GetPageSettingsData?.pageSetting?.domain}.${process.env.REACT_APP_DOMAIN}/status/support`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <VmoIcon name="external alternate" /> Preview
            </VmoButton>
          }
        />
      </div>
    </VmoMenu>
  )
}

export default StatusPageMenu
